<section id="pricing" class="bg-white py-24">
  <div class="mx-auto max-w-page px-4 sm:px-6 lg:px-8">
    <div
      class="relative overflow-hidden rounded-[2.75rem] bg-cover bg-center px-6 py-16 sm:px-10 lg:px-16 lg:py-20"
      style="background-image: url('assets/images/landing/forms.webp');">
      <div class="absolute inset-0 bg-slate-950/60"></div>
      <div class="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-slate-950/70 to-transparent"></div>

      <div class="relative mx-auto flex max-w-3xl flex-col gap-10 text-center">
        <div class="flex flex-col gap-6">
          <h2 class="text-h1 text-white">
            Build forms.
            <br>
            Collect data.
            <br>
            Discover insights.
          </h2>

          <p class="text-body1 leading-8 text-slate-100">
            Create forms, collect submissions, and use AI to understand trends,
            feedback, and operational data from one workspace.
          </p>
        </div>

        <div class="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            routerLink="/signup"
            class="inline-flex h-14 min-w-[200px] items-center justify-center rounded-full bg-white px-8 text-body2 font-semibold text-slate-950 transition hover:bg-slate-100">
            Create workspace
          </a>

          <a
            routerLink="/login"
            class="inline-flex h-14 min-w-[200px] items-center justify-center rounded-full bg-white/15 px-8 text-body2 font-semibold text-white backdrop-blur transition hover:bg-white/20">
            Sign in
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

